import * as Models from "../../ts/rlAdmin.models";
import { NotifyService } from "../../services/notify-service";
import { AdminService } from "../../services/admin-service";
import { EventService } from "../../services/event-service";
import { IPromise } from "angular";

export class IndexAdminController {

    static $inject = ["$window", "$q", "$interval", "$filter", "notifyService", "adminService", "eventService"];

    clearMatchingDocs: boolean;
    entityIDs: string[];
    offsetRecID: number;
    divisions: Models.IDivisionInfo[];
    selectedDivisionIDs: number[];
    charTypes: Models.ICharacteristicType[];
    selectedCharTypeIDs: number[];
    jobID: string;

    jobStatus: string;
    jobTotal: number;
    jobComplete: number;
    jobProgress: number;
    //jobMessages: Models.IJobMessage[];
    maxMessageTimestamp: string;

    errorMessages: Models.IJobMessage[];
    successMessages: Models.IJobMessage[];

    intervalPromise: ng.IPromise<any>;
    jobStateFailCount: number;

    resultsModalOpen: boolean;
    resultsPageSize: number;
    logStarts: { [key: number]: number };
    logTotals: { [key: number]: number };
    jobMode: "reindex" | "zip" = "reindex";

    constructor(private $window: ng.IWindowService, private $q: ng.IQService, private $interval: ng.IIntervalService, private $filter: ng.IFilterService, private notifyService: NotifyService, private adminService: AdminService, private eventService: EventService) {
        this.clearMatchingDocs = false;
        this.entityIDs = [];
        this.divisions = [];
        this.selectedDivisionIDs = [];
        this.charTypes = [];
        this.selectedCharTypeIDs = [];
        this.jobID = null;

        this.jobStatus = "";
        this.jobTotal = 1;
        this.jobComplete = 0;
        this.jobProgress = 0;
        //this.jobMessages = [];
        this.errorMessages = [];
        this.successMessages = [];
        this.maxMessageTimestamp = "";
        this.intervalPromise = null;
        this.jobStateFailCount = 0;

        this.resultsModalOpen = false;
        this.resultsPageSize = 50;
        this.logStarts = { 1: 0, 2: 0 };
        this.logTotals = { 1: 9999, 2: 9999 };
        this.SetupForm();
    }

    SetupForm() {
        this.notifyService.startProgress();
        this.adminService.getEntityIndexInfo()
            .then((result) => {
                var relationshipsCharType: Models.ICharacteristicType = {
                    charTypeID: 0,
                    charTypeName: "Relationships",
                    seqNumber: 0
                };
                this.charTypes = result.charTypes;
                this.charTypes.unshift(relationshipsCharType);
                this.divisions = result.divisions;
            }).finally(() => {
                this.notifyService.endProgress();
            });
    }

    StartPolling() {
        this.intervalPromise = this.$interval(() => this.UpdateState(), 2000);
    }

    UpdateState() {
        this.adminService.getJobState(this.jobID)
            .then((result) => {
                this.jobComplete = result.completed;
                this.MergeMessages(result.infoMessages);
                this.jobStatus = result.status;
                this.jobTotal = result.total;
                this.jobProgress = (this.jobComplete / this.jobTotal) * 100;

                if (result.status == "Done" || result.status == "Failed" || result.status == "Cancelled") {
                    this.$interval.cancel(this.intervalPromise);
                    if (result.status == "Cancelled") {
                        // stop the spinning cancel button
                        this.notifyService.broadcastDone();
                    }
                }
            }, () => {
                this.jobStateFailCount++;
                if (this.jobStateFailCount > 5) {
                    this.$interval.cancel(this.intervalPromise);
                    this.jobStatus = "Error";
                    this.notifyService.notifyError("Error updating job status");
                    this.jobStateFailCount = 0;
                }
            });
    }

    MergeMessages(messages: Models.IJobMessage[]) {
        _.forEach(messages, (message) => {
            // keep duplicate messages from being added
            if (message.timestamp > this.maxMessageTimestamp) {
                this.maxMessageTimestamp = message.timestamp;
                this.WriteToLog("infolog", message);

                //this.jobMessages.unshift(message);
            }
        });
    }

    RebuildIndex() {
        this.notifyService.startProgress();

        var promise: IPromise<Models.IJobResponse> = null;
        if (this.jobMode == "zip") {
            promise = this.adminService.zipRebuildIndex(this.selectedCharTypeIDs, this.selectedDivisionIDs, this.offsetRecID);
        } else {
            promise = this.adminService.rebuildIndex(this.selectedCharTypeIDs, this.selectedDivisionIDs, this.entityIDs, this.offsetRecID, this.clearMatchingDocs);
        }
        promise
            .then((result) => {
                this.jobID = result.jobID;
                this.notifyService.notifySuccess("Index Job started");
                this.StartPolling();
            },
                () => {
                    this.notifyService.notifyError("Error Rebuilding Index");
                })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    RebuildEntitiesStatusIndex(divID: number, processID: number, statusID: number): ng.IPromise<any> {
        this.notifyService.startProgress();

        return this.adminService.rebuildEntitiesStatusIndex(divID, processID, statusID)
            .then((result) => {
                this.jobID = result.jobID;
                this.notifyService.notifySuccess("Workflow Status Index Rebuild started");
                this.StartPolling();
            },
                () => {
                    this.notifyService.notifyError("Error Rebuilding Index");
                })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    RebuildEntitiesTemplateIndex(divID: number, charTypeID: number, templateID: number): ng.IPromise<any> {
        this.notifyService.startProgress();

        return this.adminService.rebuildEntitiesTemplateIndex(divID, charTypeID, templateID)
            .then((result) => {
                this.jobID = result.jobID;
                this.notifyService.notifySuccess("Workflow Template Index Rebuild started");
                this.StartPolling();
            },
                () => {
                    this.notifyService.notifyError("Error Rebuilding Index");
                })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    CancelReIndex() {

        this.adminService.cancelJob(this.jobID)
            .then(() => {
                // success
            }, () => {
                this.notifyService.notifySuccess("Error Cancelling Job");
            })
            .finally(() => {
                //this.notifyService.endProgress();
            });

    }

    ShowResults() {

        this.ClearLog("errorlog");
        this.ClearLog("successlog");

        this.PopulateErrorLog();
        this.PopulateSuccessLog();

        this.resultsModalOpen = true;
    }

    PopulateErrorLog() {
        var messageTypeID = 2;
        this.adminService.getJobMessages(this.jobID, messageTypeID, this.logStarts[messageTypeID], this.resultsPageSize)
            .then(result => {
                this.logTotals[messageTypeID] = result.totalCount;
                this.logStarts[messageTypeID] += this.resultsPageSize;
                _.forEach(result.messages, (msg) => {
                    this.WriteToLog("errorlog", msg);
                });

                if (this.logStarts[messageTypeID] < this.logTotals[messageTypeID]) {
                    this.PopulateErrorLog();
                }
            });
    }

    PopulateSuccessLog() {
        var messageTypeID = 1;
        this.adminService.getJobMessages(this.jobID, messageTypeID, this.logStarts[messageTypeID], this.resultsPageSize)
            .then(result => {
                this.logTotals[messageTypeID] = result.totalCount;
                this.logStarts[messageTypeID] += this.resultsPageSize;
                _.forEach(result.messages, (msg) => {
                    this.WriteToLog("successlog", msg);
                });

                if (this.logStarts[messageTypeID] < this.logTotals[messageTypeID]) {
                    this.PopulateSuccessLog();
                }
            });
    }

    ClearLog(logName: string) {
        return this.eventService.call("clear:" + logName);
    }

    WriteToLog(logName: string, message: Models.IJobMessage) {
        var output = this.$filter("date")(message.timestamp, "hh:mm:ss a") + "\n" + message.message;
        return this.eventService.call("write:" + logName, output);
    }
}